export enum ContractStatus {
	Draft = "Draft",
	TaskCompleteRequest = "Task Complete Request",
	RequestForApproval = "Request For Approval",
	Approved = "Approved",
	ChangeRequested = "Change Requested",
	Reviewed = "Reviewed",
	Rejected = "Rejected",
	Delete = "Deleted",
	Recalled = "Recalled",
	Uncertified = "Uncertified",
	Active = "Active",
	HoldRequested = "Hold Requested",
	OnHold = "On Hold",
	TerminationRequested = "Termination Requested",
	Terminated = "Terminated",
	Reinstated = "Reinstated",
	Expired = "Expired",
	Completed = "Completed",
	Extended = "Extended",
}

export enum ContractStatusId {
	Draft = 1,
	TaskCompleteRequest = 2,
	RequestForApproval = 3,
	Approved = 4,
	ChangeRequested = 5,
	Reviewed = 6,
	Rejected = 7,
	Delete = 8,
	Recalled = 9,
	Uncertified = 10,
	Active = 11,
	HoldRequested = 12,
	OnHold = 13,
	TerminationRequested = 14,
	Terminated = 15,
	Reinstated = 16,
	Expired = 17,
	Completed = 18,
	Extended = 19,
}

export enum ContractAssigned {
	AssignedToMe = 1,
	CreatedByMe = 2,
	CreatedByOthers = 3,
}

export enum ContractTakeOn {
	ContractMasterRecord = 1,
	TransactionDetail = 2,
	MixedLevel = 3,
}

export enum ContractTakeOnStatus {
	Approve = "Approve",
	Reject = "Reject",
}

export enum ContractTakeOnFileType {
	CSDSupplierMaster = 1,
	NonCSDSupplierMaster = 2,
	ContractMaster = 3,
	POContractMapping = 4,
	ExpenditurePOMapping = 5,
}

export enum ContractTakeOnSampleFile {
	SupplierMaster = "Supplier Master",
	ContractMaster = "Contract Master",
	POContractMapping = "PO-Contract Mapping",
	ExpenditurePOMapping = "Expenditure-PO Mapping",
}

export enum ContractLineDetailMilestoneStatusId {
	New = 1,
	Draft = 2,
}

export enum ContractStepStatus {
	Completed = "Completed",
	Ready = "Ready",
	Pending = "Pending",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
	Deleted = "Deleted",
	Delegated = "Delegated",
	Escalated = "Escalated",
	Cancelled = "Cancelled",
}

export enum ContractStepStatusId {
	Completed = 1,
	Ready = 2,
	Pending = 3,
	Recalled = 4,
	ChangeRequested = 5,
	Rejected = 6,
	Deleted = 7,
	Delegated = 8,
	Escalated = 9,
	Cancelled = 10,
}

export enum ContractConfirmationType {
	Approve = "approve",
	TaskCompletion = "task-complete",
	ChangeRequest = "change-request",
	Delegation = "delegate",
	Rejection = "reject",
	Recall = "recall",
	TerminationSchedule = "termination-scheduled",
}

export enum ContractActionType {
	Edit = "edit",
	Delete = "delete",
}

//PerformanceEvaluator radio buttons
export enum PerformanceEvaluator {
	EndUserDepartment = 1,
	EndUserDepartmentAndCoordinator = 2,
	Coordinator = 3,
}

export enum NewContractModulePhase {
	ContractRequest = 21,
	ContractDrafting = 22,
	InternalContractReview = 23,
	ExternalContractReview = 24,
	ContractApproval = 25,
	ContractSigning = 26,
	ContractFiling = 27,
	ContractExecution = 28,
}

export enum ExpenditureStatus {
	Draft = "Draft",
	Open = "Open",
	PartiallyCredited = "Partially Credited",
	FullyCredited = "Fully Credited",
	PartiallyPaid = "Partially Paid",
	FullyPaid = "Fully Paid",
	FullyAllocated = "Fully Allocated",
	Rejected = "Rejected",
	Deleted = "Deleted",
}

export enum ContractDetailTabs {
	ContractItems = 0,
	SupplierBid = 1,
	PerformanceEvaluation = 2,
	SupplierContract = 3,
	PORequests = 4,
	Variations = 5,
	ContractPOs = 6,
	UnpaidExpenditure = 7,
	ContractPayments = 8,
}

export enum ContractTakeOnFile {
	CSDSupplierMaster = 1,
	NonCSDSupplierMaster = 2,
	ContractMaster = 3,
	POContractMapping = 4,
	ExpenditurePOMapping = 5,
}

export enum ContractHoldStatus {
	HoldRequest = "Hold Request",
	CancelledHoldRequest = "Cancelled Hold Request",
	HoldRequestRejected = "Hold Request Rejected",
	OnHold = "On Hold",
	HoldRemovalRequest = "Hold Removal Request",
	HoldRemovalRequestRejected = "Hold Removal Request Rejected",
	HoldRemoved = "Hold Removed",
}

export enum ContractHoldStatusId {
	HoldRequest = 1,
	CancelledHoldRequest = 2,
	HoldRequestRejected = 3,
	OnHold = 4,
	HoldRemovalRequest = 5,
	HoldRemovalRequestRejected = 6,
	HoldRemoved = 7,
}

export enum ContractTerminationStatus {
	TerminationRequest = "Termination Request",
	CancelTermination = "Cancel Termination",
	TerminationRequestRejected = "Termination Request Rejected",
	Terminated = "Terminated",
	TerminationCancellationRequested = "Termination Cancellation Requested",
	TerminationCancellationRequestRejected = "Termination Cancellation Request Rejected",
	TerminationCancelled = "Termination Cancelled",
}

export enum ContractTerminationStatusId {
	TerminationRequest = 1,
	CancelTermination = 2,
	TerminationRequestRejected = 3,
	Terminated = 4,
	TerminationCancellationRequested = 5,
	TerminationCancellationRequestRejected = 6,
	TerminationCancelled = 7,
}

// modulePhase.enum.ts
export enum ModulePhase {
	// PR Workflow
	PRCreation = 1,
	DepartmentalApproval = 2,
	SCM_Specification = 3,
	DOA = 4,
	FinanceAllocation = 6,
	DepartmentalAllocation = 7,
	FinanceConsolidation = 8,
	Approval = 9,
	DOA_2 = 10,

	// Bid Workflow
	BidCreation = 11,
	BidSpecification = 13,
	BidApproval = 15,
	BidPublishing = 16,
	BidEvaluation = 17,
	BidAward = 20,
	LimitedItemSupplierMappingCreation = 45,
	LimitedItemSupplierMappingApproval = 46,
	BidCommitteeChange = 47,
	BidCommitteeChangeApproval = 48,
	BidAdjudication = 52,
	SupplierBidding = 53,
	ManualBidCapturing = 54,
	PriceReading = 77,
	TestForResponsiveness = 78,
	EvaluationReview = 79,

	// Contract Workflow
	ContractRequest = 21,
	ContractDrafting = 22,
	InternalContractReview = 23,
	ExternalContractReview = 24,
	ContractApproval = 25,
	ContractSigning = 26,
	ContractFiling = 27,
	ContractExecution = 28,

	// PO Workflow
	POCreation = 29,
	PODeptApproval = 30,
	PODoa = 31,
	POGeneration = 32,
	POSigning = 33,
	POCreation_2 = 34,
	PODeptApproval_2 = 35,
	PODoa_2 = 36,
	POGeneration_2 = 37,
	POSigning_2 = 38,

	// Variation Workflow
	VariationCreation = 39,
	VariationDeptApproval = 40,
	VariationD0A = 41,
	VariationCreation_2 = 42,
	VariationDeptApproval_2 = 43,
	VariationDOA_2 = 44,

	// Hold Workflow
	HoldRequest = 55,
	HoldRequestReview = 56,
	HoldRequestApproval = 57,
	HoldRemovalRequest = 58,
	HoldRemovalRequestReview = 59,
	HoldRemovalRequestApproval = 60,

	// Termination Workflow
	TerminationRequest = 61,
	TerminationRequestReview = 62,
	TerminationRequestApproval = 63,

	// Reinstatement Workflow for remove terminated contract
	ReinstatementRequest = 64,
	ReinstatementRequestReview = 65,
	ReinstatementRequestApproval = 66,

	ChangeOrderCreation = 67,
	IntraDepartmentBudgetAllocation = 68,
	FinanceBudgetAllocation = 69,
	CO_DOA = 70,
}

export enum ContractAction {
	Hold = "Hold",
	Terminate = "Termination",
	HoldDelete = "Hold Delete",
	TerminationDelete = "Termination Delete",
}

export enum WFTransactionType {
	NewContract = 1,
	ContractAddendumExtension = 2,
	ContractRequisition = 3,
	NewPanel = 4,
	PanelAddendumExtension = 5,
	PanelRequisition = 6,
	ContractInventoryTransfer = 7,
	StandardPurchase = 8,
	LimitedSuppliesItemSupplierMapping = 9,
	BidCommitteeChanges = 10,
	NewBid = 11,
	NewGLAccount = 12,
	NewAnnualBudget = 13,
	MidTermReviewChangeOrder = 14,
	BidCreationAndGeneration = 15,
	BidEvaluationCriteriaDefinition = 16,
	BidEvaluation = 17,
	PurchaseRequisition = 18,
	TravelRequisition = 19,
	PurchaseOrderRequest = 20,
	ContractHold = 21,
	ContractHoldRemoval = 22,
	ContractTermination = 23,
	ContractReinstatement = 24,
	AdHocChangeOrder = 25,
	RequisitionChangeOrder = 26,
	SourcingChangeOrder = 27,
}
